import * as React from 'react';
import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import StepContent from '@mui/material/StepContent';
import Button from '@mui/material/Button';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import AccountInfo from './account-info';
import AccountInfoStep1 from './account-info-step1';
import { useState } from 'react';
import AccountInfoStep2 from './account-info-step2';
import AccountInfoStep3 from './account-info-step3';
import { Link, useNavigate } from 'react-router-dom';
import { Grid } from '@mui/material';

const steps = [
  {
    label: 'مشخصات کاربر',
    description: `For each ad campaign that you create, you can control how much
              you're willing to spend on clicks and conversions, which networks
              and geographical locations you want your ads to show on, and more.`,
  },
  {
    label: 'اطلاعات تماس',
    description:
      'An ad group contains one or more ads which target a shared set of keywords.',
  },
  {
    label: 'ساخت اکانت',
    description: `Try out different ad text to see what brings in the most customers,
              and learn how to enhance your ads using features like ad extensions.
              If you run into any problems with your ads, find out how to tell if
              they're running and how to resolve approval issues.`,
  },
];

export default function RegisteryAccount() {
    const [password, setPassword ] = useState('')
    const [username, setUserName ] = useState('')
    const [last_name, setLastName ] = useState('')
    const [email, setEmail ] = useState('')
    const [mobileNumber, setMobileNumber ] = useState('')

    const [activeStep, setActiveStep] = useState(0);
    const navigate = useNavigate()


    const handleNext = value => {
        console.log("handleClose", value)
        if(value?.username){
            setUserName(value?.username)
        }
        if(value?.last_name){
            setLastName(value?.last_name)
        }
        
        if(value?.email){
            setEmail(value?.email)
        }
        if(value?.mobileNumber){
            setMobileNumber(value?.mobileNumber)
        }
        if(value?.password){
            setPassword(value?.password)
        }

        setActiveStep((prevActiveStep) => prevActiveStep + 1);
    };

    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };

    const handleReset = () => {
        navigate(`/login`)
        // setActiveStep(0);
    };

    return (
        <React.Fragment>
            <Box sx={{ maxWidth: 800 }}>
                <Stepper activeStep={activeStep} orientation="vertical">
                    {steps.map((step, index) => (
                        <Step key={step.label}>
                            <StepLabel
                                optional={
                                    index === 2 ? (
                                    <Typography variant="caption">آخرین مرحله</Typography>
                                    ) : null
                                }
                                >
                                    <Typography 
                                        fontFamily='b_mitra' 
                                        component="div"
                                        variant="h6"
                                        >
                                        {step.label}
                                    </Typography>
                            </StepLabel>
                            <StepContent>
                                {index === 0 ?
                                    <div>
                                        <AccountInfoStep1 user_Name={username} Famili={last_name} onNext={handleNext}/>
                                    </div>
                                :
                                    index === 1 ?
                                        <AccountInfoStep2 userEmail={email} userPhone={mobileNumber} onNext={handleNext} onBack={handleBack}/>
                                    :
                                        <AccountInfoStep3 
                                            onNext={handleNext} 
                                            onBack={handleBack} 
                                            last_name={last_name} 
                                            username={username}  
                                            email={email}
                                            mobileNumber={mobileNumber}
                                            />
                                }
                                
                            </StepContent>
                        </Step>
                    ))}
                </Stepper>
                {activeStep === steps.length && (
                    <Paper square elevation={0} sx={{ p: 3 }}>
                    <Typography
                        fontFamily='b_mitra' 
                        component="div"
                        variant="h6"
                        >
                        ثبت نام شما با موفقیت تمام شد .
                    </Typography>
                    <Button onClick={handleReset} sx={{ mt: 1, mr: 1 }}>
                        <Typography 
                            fontFamily='b_mitra' 
                            component="div"
                            variant="h6"
                            >
                            ورود به حساب
                        </Typography>                
                    </Button>
                    </Paper>
                )}
            </Box>
            <Grid container>
                <Grid item xs={10}>
                    <Link to="/login" 
                        color="primary.main" 
                        >
                        <Typography 
                            fontFamily="Segoe UI"
                            component="div"
                            variant="p"
                            color={"primary"}
                            >
                            به حساب خود وارد شوید
                        </Typography>
                    </Link>
                </Grid>
            </Grid>
        </React.Fragment>
    );
}